import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/utils/cn';

type Variant = 'primary' | 'ghost' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children?: ReactNode;
}

const variantClass: Record<Variant, string> = {
  primary: 'bg-accent text-accent-contrast hover:opacity-90 disabled:opacity-50',
  ghost: 'bg-transparent text-fg hover:bg-bg-elevated border border-border',
  danger: 'bg-danger text-white hover:opacity-90 disabled:opacity-50',
};

export function Button({ variant = 'primary', loading, disabled, className, children, ...rest }: Props) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={cn(
        'inline-flex h-11 items-center justify-center rounded-xl px-4 text-sm font-medium transition-opacity',
        'disabled:cursor-not-allowed',
        variantClass[variant],
        className
      )}
    >
      {loading ? <span className="animate-pulse">…</span> : children}
    </button>
  );
}
